var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#737373",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1678_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69853 1.25867C7.19002 0.113808 8.81031 0.113808 9.30181 1.25867L10.7893 4.72358C10.8212 4.79776 10.8903 4.84743 10.9684 4.8547L14.7132 5.2031C15.9538 5.31852 16.4488 6.86198 15.518 7.68228L12.6926 10.1721C12.6327 10.2249 12.6057 10.307 12.6235 10.3862L13.4504 14.0665C13.7224 15.2769 12.4172 16.2375 11.3439 15.5983L8.11021 13.6722C8.04229 13.6317 7.95804 13.6317 7.89012 13.6722L4.65641 15.5983C3.58315 16.2375 2.27798 15.2769 2.54995 14.0665L3.37682 10.3862C3.39462 10.307 3.36767 10.2249 3.30777 10.1721L0.482344 7.68228C-0.448511 6.86198 0.0465375 5.31852 1.28716 5.2031L5.03192 4.8547C5.11008 4.84743 5.17917 4.79776 5.21102 4.72358L6.69853 1.25867ZM8.19913 1.73206C8.12355 1.55601 7.87679 1.55601 7.80121 1.73206L6.3137 5.19697C6.10901 5.67376 5.66038 6.00141 5.14308 6.04954L1.39832 6.39794C1.21135 6.41533 1.12945 6.65307 1.27572 6.78197L4.10114 9.2718C4.49052 9.61493 4.66132 10.1433 4.54763 10.6493L3.72076 14.3295C3.6775 14.5221 3.8828 14.6623 4.04232 14.5673L7.27604 12.6412C7.72233 12.3754 8.27801 12.3754 8.72429 12.6412L11.958 14.5673C12.1175 14.6623 12.3228 14.5221 12.2796 14.3295L11.4527 10.6493C11.339 10.1433 11.5098 9.61493 11.8992 9.2718L14.7246 6.78197C14.8709 6.65307 14.789 6.41533 14.602 6.39794L10.8573 6.04954C10.34 6.00141 9.89133 5.67376 9.68664 5.19697L8.19913 1.73206Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1678_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.46b80b52bd04e26be5c1b15910905ff3.svg";
export { ForwardRef as ReactComponent };